'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _ButtonToolbar = require('react-bootstrap/lib/ButtonToolbar');

var _ButtonToolbar2 = _interopRequireDefault(_ButtonToolbar);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../../../common');

var _mightyFields = require('../../../../lib/mighty-fields');

var _commonFormsy = require('../../../common-formsy');

var _validationRules = require('../../../common-formsy/validationRules');

var _validationRules2 = _interopRequireDefault(_validationRules);

var _FormManager = require('../../../../lib/mighty-fields/FormManager');

var _FormManager2 = _interopRequireDefault(_FormManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var notFilledIn = _validationRules2.default.notFilledIn;
var CapitalFundingForm = (_dec = (0, _mobxReact.inject)('CapitalFundingStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(CapitalFundingForm, _Component);

  function CapitalFundingForm(props) {
    _classCallCheck(this, CapitalFundingForm);

    var _this = _possibleConstructorReturn(this, (CapitalFundingForm.__proto__ || Object.getPrototypeOf(CapitalFundingForm)).call(this, props));

    _this.formManager = new _FormManager2.default({
      fieldSets: _this.fieldSets,
      model: props.capitalFunding,
      onSave: _this.onSave,
      onSuccess: props.onClose
    });
    return _this;
  }

  _createClass(CapitalFundingForm, [{
    key: 'isNotDuplicateProvider',
    value: function isNotDuplicateProvider(value) {
      var _props = this.props,
          capitalFunding = _props.capitalFunding,
          CapitalFundingStore = _props.CapitalFundingStore,
          lienId = _props.lienId;


      if (notFilledIn(value) || notFilledIn(value.capital_provider)) {
        return true;
      }

      var existingFunding = CapitalFundingStore.getFundingByProvider(value.capital_provider, lienId);
      return existingFunding === null || existingFunding.id === capitalFunding.id;
    }
  }, {
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _props2, capitalFunding, CapitalFundingStore, lienId, submitData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props2 = this.props, capitalFunding = _props2.capitalFunding, CapitalFundingStore = _props2.CapitalFundingStore, lienId = _props2.lienId;
                submitData = _extends({}, data, {
                  id: capitalFunding.id || _uuid2.default.v4(),
                  lien: lienId
                });


                submitData.capital_provider.id = submitData.capital_provider.id || _uuid2.default.v4();

                _context.next = 5;
                return CapitalFundingStore.upsert(submitData);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'onRemoveCapitalFunding',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _props3, CapitalFundingStore, lienId, onClose, capitalFundingId;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _props3 = this.props, CapitalFundingStore = _props3.CapitalFundingStore, lienId = _props3.lienId, onClose = _props3.onClose, capitalFundingId = this.formManager.model.get('id');
                _context2.next = 3;
                return CapitalFundingStore.delete(capitalFundingId, lienId);

              case 3:
                onClose();

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onRemoveCapitalFunding() {
        return _ref2.apply(this, arguments);
      }

      return onRemoveCapitalFunding;
    }()
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'detail-block-form' },
        _react2.default.createElement(
          _commonFormsy.Form,
          this.formManager.formProps,
          _react2.default.createElement(
            _Grid2.default,
            { fluid: true },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_mightyFields.FormFieldSets, _extends({
                fieldSets: this.fieldSets
              }, this.formManager.formGroupsProps)),
              this.formManager.errorMessages.map(function (error) {
                return _react2.default.createElement(
                  _Row2.default,
                  { className: 'text-danger', key: error.field },
                  _react2.default.createElement(
                    'strong',
                    null,
                    error.field
                  ),
                  ' - ',
                  error.message
                );
              }),
              _react2.default.createElement(
                'div',
                { className: 'flex-between' },
                _react2.default.createElement(
                  'div',
                  null,
                  this.formManager.model.get('id') && _react2.default.createElement(
                    _Button2.default,
                    {
                      bsStyle: 'link',
                      onClick: this.onRemoveCapitalFunding,
                      className: 'btn-remove-capital-funding'
                    },
                    _react2.default.createElement(_common.Icon, { type: 'times' }),
                    'Remove Capital Provider'
                  )
                ),
                _react2.default.createElement(
                  _ButtonToolbar2.default,
                  { className: 'pull-right' },
                  _react2.default.createElement(
                    _Button2.default,
                    { onClick: this.props.onClose },
                    this.props.cancelText
                  ),
                  _react2.default.createElement(
                    _Button2.default,
                    {
                      bsStyle: 'primary',
                      disabled: this.formManager.submitDisabled(),
                      type: 'submit'
                    },
                    this.formManager.isSubmitting ? 'Saving...' : 'Save'
                  )
                )
              )
            )
          ),
          _react2.default.createElement('hr', null)
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSets',
    get: function get() {
      return [[{
        createFields: [{ field: 'name', populateFromSearch: true }],
        editProps: {
          validationErrors: { isNotDuplicateProvider: 'A capital provider may only be added once.' },
          validations: { isNotDuplicateProvider: this.isNotDuplicateProvider }
        },
        endpoint: '/capital-providers/',
        field: 'capital_provider',
        required: true,
        type: 'objectSearchCreate'
      }, { field: 'ownership_percentage', type: 'percentage' }, { field: 'notes', type: 'text' }]];
    }
  }]);

  return CapitalFundingForm;
}(_react.Component), _class3.defaultProps = {
  cancelText: 'Cancel',
  capitalFunding: {},
  onClose: _noop3.default
}, _class3.propTypes = {
  cancelText: _propTypes2.default.string,
  capitalFunding: _propTypes2.default.object,
  CapitalFundingStore: _propTypes2.default.object.isRequired,
  lienId: _propTypes2.default.string.isRequired,
  onClose: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onRemoveCapitalFunding', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onRemoveCapitalFunding'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = CapitalFundingForm;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(notFilledIn, 'notFilledIn', '/app/src/components/page-case/main-details/capital-fundings/CapitalFundingForm.js');
  reactHotLoader.register(CapitalFundingForm, 'CapitalFundingForm', '/app/src/components/page-case/main-details/capital-fundings/CapitalFundingForm.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-details/capital-fundings/CapitalFundingForm.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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